// The fetch of the newest items, one at a time. Asked for while one runs
// (the stream catching up during the first fetch or a poll), it runs once
// more after it, for what came in meanwhile; every ask in that time gets
// that one run. Never two at once: two answers with the same items would
// leave the first one's hidden.
export const catchUp = (fetch) => {
  let running = null
  let next = null
  // start now (the first fetch, the poll), and keep track of it
  const run = (...args) => {
    const done = Promise.resolve(fetch(...args)).finally(() => {
      if (running === done) running = null
    })
    running = done
    return done
  }
  // start now, or once after the running one, however that one ends
  const runNewer = () => {
    if (!running) return run()
    if (!next) {
      const after = () => {
        // stopped meanwhile: nothing more to fetch
        if (next !== queued) return undefined
        next = null
        return run()
      }
      const queued = running.then(after, after)
      next = queued
    }
    return next
  }
  // no queued fetch any more (a logout: it would run with the old login)
  const stop = () => {
    next = null
  }
  return { run, runNewer, stop }
}
